import { CalendarMonth } from "@mui/icons-material";
import { Typography } from "@mui/material";
import { SubtypeToolboxPlaceholderScaffold } from "../../../pages/actionModules/ActionModuleEditor/SubtypeEditor/SubtypeToolbox";
import { SubtypeDefinition } from "../actionModule";
import { PropertyTypes } from "../editor/subtypeEditorTypes";
import { BaseModuleSubtype, Subtype } from "./subtype";
import { useTranslation } from "react-i18next";
import { SurveyAppointmentCalendarEditor } from "../../../components/actionModules/subtypes/surveyAppointment/SurveyAppointmentCalendarEditor";
import SurveyAppointmentSubtypeDetails from "../../../pages/incentivation/actionModules/incentivationTable/subtype/details/SurveyAppointmentSubtypeDetails";
import { SurveyAppointmentSubtypeDataModel } from "./surveyAppointmentSubtype";
import SurveyAppointmentSubtypeSummary from "../../../pages/incentivation/actionModules/incentivationTable/subtype/summary/SurveyAppointmentSubtypeSummary";

export const SurveyAppointmentSubtype: SubtypeDefinition = {
    name: "actionModules.subtypes.surveyAppointment.name",
    type: Subtype.SurveyAppointmentModuleSubtype,
    icon: <CalendarMonth />,
    toolboxPlaceholder: ToolboxPlaceholder,
    editorPreview: EditorPreview,
    subtypeDataView: (props) => <SurveyAppointmentSubtypeDetails
        subtype={props.subtype as BaseModuleSubtype}
        subtypeData={props.subtypeData as SurveyAppointmentSubtypeDataModel} />,
    subtypeDataSummaryView: (props) => <SurveyAppointmentSubtypeSummary
        subtype={props.subtype as BaseModuleSubtype}
        subtypeData={props.subtypeData as SurveyAppointmentSubtypeDataModel} />,
    editableProperties: [
        {
            name: "calendarServiceModule",
            displayName: "actionModules.subtypes.surveyAppointment.calendarServiceModule",
            propertyType: PropertyTypes.complex,
            editor: SurveyAppointmentCalendarEditor,
        },
        {
            name: "groupAppointments",
            displayName: "actionModules.subtypes.surveyAppointment.groupAppointments",
            propertyType: PropertyTypes.boolean
        },
        {
            name: "allowNoViableEvent",
            displayName: "actionModules.subtypes.surveyAppointment.allowNoViableEvent",
            propertyType: PropertyTypes.boolean
        },
        {
            name: "allowReject",
            displayName: "actionModules.subtypes.surveyAppointment.allowReject",
            propertyType: PropertyTypes.boolean
        },
        {
            name: "allowOneEventPerCompletion",
            displayName: "actionModules.subtypes.surveyAppointment.allowOneEventPerCompletion",
            propertyType: PropertyTypes.boolean
        },
    ]
};

function EditorPreview() {
    const { t } = useTranslation();
    return <Typography variant="caption">{t("actionModules.subtypes.base.noPreview")}</Typography>;
}

function ToolboxPlaceholder() {
    return <SubtypeToolboxPlaceholderScaffold
        icon={<CalendarMonth />}
        name="actionModules.subtypes.surveyAppointment.name" />;
}